<template>
<div class="app__page -options">
  <div class="options-panel">
    <h3>Preparing for first run</h3>
    <p>Database type: {{type}}</p>
    <div class="progress-bar">
      <div class="progress-bar__bar" :style="{width: progress}"></div>
    </div>
    <ul>
      <li v-for="i in item" :key="i">{{i}}</li>
    </ul>
  </div>
</div>
</template>

<script>
import {getDatabase} from "../../api/index.js";
export default {
  data: function(){
    return {
      type: getDatabase().getName(),
      progress: "0%",
      item:["waiting"]
    }
  },
  mounted(){
    getDatabase().update( (cur,total, item)=>{
        this.progress = Math.floor( (cur/total) * 100) + "%"
        this.item = Array.isArray(item) ? item : [item];
      }).then(async () => {
        this.$router.push({ name:'start'});
        }, err => {
          alert("Failed to update, please try again.");
          console.error(err);
          this.$router.push({ name:'start'});
        })
    
  }
};
</script>
<style>

.options-panel{
  position: absolute;
  top:50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/page-precache.vue